/**
 * Helpers de formato compartidos — antes reimplementados de forma idéntica
 * en 9 páginas (moneda) y 4 archivos (tiempo relativo).
 */

/**
 * Formatea un importe en euros según el idioma activo.
 * @param {number} n
 * @param {string} lang - i18n.language ("es" | "en" | ...)
 * @param {Intl.NumberFormatOptions} [opts] - p.ej. { minimumFractionDigits: 0 }
 */
export function formatCurrency(n, lang, opts) {
  const v = Number(n) || 0;
  // Un mismo importe se ve igual en todas las pantallas: sin decimales si es
  // entero ("600 €"), con dos si no ("2593,55 €").
  return new Intl.NumberFormat(lang === "es" ? "es-ES" : "en-GB", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
    ...opts,
  }).format(v);
}

/**
 * Texto relativo tipo "hace 5 minutos" / "5 minutes ago", usando las claves
 * i18n ya existentes (activity.ago_*).
 * @param {(key: string, opts?: object) => string} t - función t() de react-i18next
 * @param {string} iso - fecha ISO
 */
export function timeAgo(t, iso) {
  if (!iso) return "—";
  const diff = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return t("activity.ago_seconds_other", { count: Math.round(diff) });
  if (diff < 3600) return t("activity.ago_minutes_other", { count: Math.round(diff / 60) });
  if (diff < 86400) return t("activity.ago_hours_other", { count: Math.round(diff / 3600) });
  return t("activity.ago_days_other", { count: Math.round(diff / 86400) });
}
